import Swiper, { Pagination, Grid, Navigation } from "swiper";
// import styles bundle
import '../../../node_modules/swiper/swiper.min.css';

export default class ManagersSwiper {
    constructor(element) {
        this.passedElement = element;
        this.searchQuery = "";
        this.paginationContainer = this.passedElement.querySelector('.pagination-container');
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.getElements();
            this.addEventListeners();
        }
    }

    setSwiper = (swiperContainer) => {
        Swiper.use([Pagination, Grid, Navigation]);
        const logosSwiper = new Swiper(swiperContainer, {
            direction: 'horizontal',
            loop: false,
            slidesPerView: 1,
            grid: {
                rows: 4,
                fill: "row",
            },
            spaceBetween: 0,
            pagination: {
                el: ".swiper-pagination",
                dynamicBullets: true,
                dynamicMainBullets: 3,
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }

    handleIntersect = (entries, observer) => {
        entries.forEach((entry) => {
            entry.isIntersecting ? this.paginationContainer.classList.add('open') : this.paginationContainer.classList.remove('open');
        });
    };

    createObserver = (boxElement) => {
        let observer;
        
        let options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.25
        };
        
        observer = new IntersectionObserver(this.handleIntersect, options);
        observer.observe(boxElement);
    }

    getElements = () => {
        this.setSwiper(this.passedElement);
        this.createObserver(this.passedElement);
    }

    addEventListeners = () => {
        //Add all event listeners bellow
    }
}